import BulkUnpair from "../../actions/BulkUnpair.js";
import BulkPair from "../../actions/BulkPair.js";
/* eslint-disable react/jsx-filename-extension */
function installBulk(molten, {
  parentBlueprint,
  blueprint,
  path,
  relationship
}) {
  molten.addPlugin('Action', {
    matches: {
      use: 'actionBar',
      client: 'GroupScreen'
    },
    handles: context => {
      const cxt = context;
      return cxt?.clientProps?.relationship?.path === relationship?.parentRelationship?.path;
    },
    layout: {
      group: ['Pair'],
      groupIcons: ['fa fa-link fa-fw'],
      groupNames: [() => null],
      sort: 'zBulk.z',
      sectionName: 'Bulk'
    },
    ...BulkPair({
      path,
      parentBlueprint,
      blueprint
    })
  });
  molten.addPlugin('Action', {
    matches: {
      use: 'actionBar',
      client: 'GroupScreen'
    },
    handles: context => {
      const cxt = context;
      return cxt?.clientProps?.relationship?.path === relationship?.parentRelationship?.path;
    },
    layout: {
      group: ['Pair'],
      groupIcons: ['fa fa-link fa-fw'],
      groupNames: [() => null],
      sort: 'zBulk.zz',
      sectionName: 'Bulk'
    },
    ...BulkUnpair({
      path,
      parentBlueprint,
      blueprint
    })
  });
}
export default {
  installBulk
};